import Vue from 'vue'
import Router from 'vue-router'
const Index = () => import('@/components/home/index')
const Download = () => import('@/components/home/download')
const setMeal = () => import('@/components/home/set-meal')
const payList = () => import('@/components/home/pay-list')
import Cookies from 'js-cookie'
import 'element-ui/lib/theme-chalk/index.css'
import ElementUI from 'element-ui'
// 日活上报
import dailyReport from '@/util/daily-report'
Vue.use(ElementUI)
Vue.use(Router)
window.Vue = Vue;
const isProd = process.env.NODE_ENV === 'production'
const homeRouter = new Router({
  base: isProd ? '/en' : '/',
  mode: isProd ? 'history' : 'hash',

  fallback: false,
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },

  routes: [
    {
      path: '/',
      name: 'index',
      meta: {
        title: 'Rain Classroom'
      },
      component: Index,
    },
    {
      path: '/download',
      name: 'download',
      meta: {
        title: 'Rain Classroom'
      },
      component: Download,
    },
    {
      path: '/set-meal',
      name: 'setMeal',
      meta: {
        title: '雨课堂定价'
      },
      component: setMeal,
    },
    {
      path: '/pay-list',
      name: 'payList',
      meta: {
        title: '雨课堂定价'
      },
      component: payList,
    },
    {
      path: '*',
      redirect: '/'
    },
  ]
})

homeRouter.beforeEach((to, from, next) => {
  // 解决 标题闪烁问题
  let isEnglish = Cookies.get("django_language") == 'en'
  if(isEnglish){ 
    document.title = 'Rain Classroom'
  }else {
    document.title = to.meta.title
  }
  next()
})

homeRouter.afterEach(route=>{
  // google统计
  setTimeout(() => {
    // pv单页面统计
    typeof dailyReport !== 'undefined' && dailyReport.reportLog();
  }, 1000);
});

export default homeRouter;
